import { EventBus } from './event-bus';
let eventBus = new EventBus();
function on(type, fn) {
    return eventBus.on(type, fn);
}
function destroy() {
    eventBus.destroy();
    eventBus = new EventBus();
}
// @ts-expect-error
if (navigator.mediaSession != null) {
    // @ts-expect-error
    navigator.mediaSession.setActionHandler('pause', () => {
        eventBus.emit('pause');
    });
    // @ts-expect-error
    navigator.mediaSession.setActionHandler('play', () => {
        eventBus.emit('play');
    });
}
export default { on, destroy };
//# sourceMappingURL=media-action.js.map